<template>
  <!--Products navbar contains (sport type, equipment, vendor, tags, stroke)-->
  <v-toolbar dense color="secondary" dark>
    <v-spacer></v-spacer>
    <v-menu
      open-on-hover
      bottom
      offset-y
      v-for="item in horizontalSecondNavItems"
      :key="item.title"
      :id="'marketplace_sidenav_' + item.title"
    >
      <!--navbar item title here-->
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" text exact>
          <!-- <v-icon left> {{ item.icon }}</v-icon> -->
          <span class="hidden-sm-and-down">
            {{ item.title }}
          </span>
        </v-btn>
      </template>
      <!--navbar item filter-->
      <v-list>
        <v-list-item
          v-for="(item, index) in catValueListArray(item.title)"
          :key="index"
          :id="'marketplace_' + item"
        >
          <v-list-item-title>{{ item }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-spacer />
  </v-toolbar>
</template>

<script>
import { getCatValues } from "../../mixins/getCatValues";
export default {
  name: "ProductsNavbar",
  mixins: [getCatValues],
  data() {
    return {};
  },
  computed: {
    horizontalSecondNavItems() {
      return [
        { icon: "sport", title: "SPORT_TYPE", link: "/auth/signin" },
        { icon: "Vendor", title: "Vendor", link: "/auth/signup" },
        { icon: "Vendor", title: "EQUIPMENT", link: "/auth/signup" },
        { icon: "Vendor", title: "Tags", link: "/auth/signup" },
        { icon: "chat", title: "STROKE", link: "/posts" }
      ];
    }
  },
  methods: {
    handleGetCatValuesList() {
      //reach out of Vuex store, fire action that gets athletes
      this.$store.dispatch("allCategoryValue", {});
    }
  },
  created() {
    this.handleGetCatValuesList();
    //this.allowedClubs = this.getAllowedClubs();
  }
};
</script>
